import {useEffect, useState} from "react";

export function useCheckBrowser({disabled = false} = {}) {
  const [isWrongBrowserDetected, setIsWrongBrowserDetected] = useState(false);

  useEffect(() => {
    if (disabled) return;
    // Check if browser is Chromium-based
    const isChromiumBased = detectChromiumBrowser();

    if (!isChromiumBased) {
      setIsWrongBrowserDetected(true);
      console.log("wrong browser detected");
    }
  }, [disabled]);

  return {isWrongBrowserDetected};
}

function detectChromiumBrowser() {
  // Check for Chrome/Chromium using multiple methods
  const userAgent = navigator.userAgent.toLowerCase();

  // Check if it's explicitly Firefox, Safari (non-Chromium), or other non-Chromium browsers
  const isFirefox = userAgent.includes("firefox");
  const isSafari = userAgent.includes("safari") && !userAgent.includes("chrome");

  if (isFirefox || isSafari) {
    return false;
  }

  // Check for Chrome/Chromium indicators
  const hasChrome = userAgent.includes("chrome") || userAgent.includes("chromium");
  const hasChromeObject = typeof window.chrome !== "undefined";

  // Additional check for Edge Chromium (which is Chromium-based)
  const isEdgeChromium = userAgent.includes("edg/");

  // Check if it's Opera (which is Chromium-based)
  const isOpera = userAgent.includes("opr/") || userAgent.includes("opera");

  return hasChrome || hasChromeObject || isEdgeChromium || isOpera;
}
